<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar *ngIf="!isReadonly">

            <span class="example-spacer"></span>

            <button mat-icon-button class="crud_action" matTooltip="add a test step" (click)="createTestStep()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- SN Column -->
            <ng-container matColumnDef="sn">
                <th mat-header-cell *matHeaderCellDef> SN </th>
                <td mat-cell *matCellDef="let element"> {{element.sn}} </td>
            </ng-container>

            <!-- Method Column -->
            <ng-container matColumnDef="method">
                <th mat-header-cell *matHeaderCellDef> Method </th>
                <td mat-cell *matCellDef="let element"> {{element.method}} </td>
            </ng-container>

            <!-- Expected Result Column -->
            <ng-container matColumnDef="expected_result">
                <th mat-header-cell *matHeaderCellDef> Expected Result </th>
                <td mat-cell *matCellDef="let element"> {{element.expected_result}} </td>
            </ng-container>

            <!-- Result Column -->
            <ng-container matColumnDef="result">
                <th mat-header-cell *matHeaderCellDef> Result </th>
                <td mat-cell *matCellDef="let element"> {{element.result}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectTestStep(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>
